import { inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export class CustomPaginatorIntl extends MatPaginatorIntl {
  private readonly translate = inject(TranslateService);

  override itemsPerPageLabel = '';
  override nextPageLabel = '';
  override previousPageLabel = '';
  override firstPageLabel = '';
  override lastPageLabel = '';
  of = '';

  constructor() {
    super();
    this.translate.get('Items Per Page').subscribe((val) => {
      this.itemsPerPageLabel = val;
    }); // Items per page
    this.translate.get('Next Page').subscribe((val) => {
      this.nextPageLabel = val;
    }); // Next page
    this.translate.get('Previous Page').subscribe((val) => {
      this.previousPageLabel = val;
    }); // Previous page
    this.translate.get('First Page').subscribe((val) => {
      this.firstPageLabel = val;
    }); // First page
    this.translate.get('Last Page').subscribe((val) => {
      this.lastPageLabel = val;
    }); // Last page
    this.translate.get('of').subscribe((val) => {
      this.of = val;
    }); // Date
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.of} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.of} ${length}`;
  };
}
